<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Master Branch</div>
        <div>
          <bread-crumb :bread-crumbs="['Master Bank', 'Master Bank Value']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <!-- <v-toolbar flat dense>
        <v-toolbar-title>Master Branch</v-toolbar-title>
      </v-toolbar> -->

      <v-row class="ms-1 me-1">
        <v-col cols="12" md="2" lg="2" xs="12" class="mt-6">
          <v-text-field
            clearable
            dense
            outlined
            placeholder="Branch code"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" lg="2" xs="12" class="mt-6">
          <v-text-field
            clearable
            dense
            outlined
            placeholder="Branch Name"
          ></v-text-field>
        </v-col>
        <div>
          <v-btn depressed  small class="mt-6 text-capitalize" color="primary"
            >Search</v-btn
          >
        </div>
        <template>
          <v-dialog persistent v-model="dialog" max-width="700px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn depressed 
                color="primary"
                dark
                small
                outlined
                class="mt-6 ms-2 text-capitalize"
                v-bind="attrs"
                v-on="on"
              >
              <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
              </v-btn>
            </template>
            <v-card>
              <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
                <span class="subtitleFontsize">{{ formTitle }}</span>
                <v-spacer></v-spacer>
                <v-btn depressed  small icon @click="close">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="mt-5">
                <v-row>
                  <v-col cols="12" sm="6" md="6"
                    ><label class="my-0 labelFontsize"> Swift Bank </label>
                    <v-autocomplete
                      class="rounded"
                      :items="items"
                      v-model="addmasterbranch.swift_bank"
                      disabled
                      background-color="grey lighten-4"
                      dense
                      outlined
                      placeholder="Swift Bank"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"
                    ><label class="my-0 labelFontsize"> Country </label>
                    <v-autocomplete
                      class="rounded"
                      :items="CountryList"
                      v-model="addmasterbranch.country_name"
                      dense
                      disabled
                      background-color="grey lighten-4"
                      outlined
                      placeholder="Country"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"
                    ><label class="my-0 labelFontsize">Bank</label>
                    <v-text-field
                      v-model="addmasterbranch.name"
                      class="rounded"
                      disabled
                      background-color="grey lighten-4"
                      dense
                      outlined
                      placeholder="Bank"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"
                    ><label class="my-0 labelFontsize">
                      Bank Branch Code
                    </label>
                    <v-text-field
                      class="rounded"
                      dense
                      outlined
                      placeholder="Bank Branch Code"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <label class="my-0 labelFontsize"> Branch Name </label>
                    <v-text-field
                      class="rounded"
                      dense
                      outlined
                      placeholder="Branch Name"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="6"
                    ><label class="my-0 labelFontsize">Address</label>
                    <v-text-field
                      class="rounded"
                      dense
                      outlined
                      placeholder="Address"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"
                    ><label class="my-0 labelFontsize"> City </label>
                    <v-text-field
                      class="rounded"
                      dense
                      outlined
                      placeholder="City"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <label class="my-0 labelFontsize"> Postcode </label>
                    <v-text-field
                      class="rounded"
                      dense
                      outlined
                      placeholder="Postcode"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <label class="my-0 labelFontsize"> Status </label>
                    <v-autocomplete
                      class="rounded"
                      dense
                      outlined
                      placeholder="Status"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn depressed 
                  small
                  color="primary"
                  class="text-capitalize"
                  @click="save()"
                >
                <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
                </v-btn>
                <v-btn depressed 
                  small
                  color="primary"
                  class="text-capitalize ms-2"
                  @click="close"
                  outlined
                >
                <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="12" md="2" lg="3" xs="12" class="ms-4">
          <label class="required" style="font-size: 16px"
            >Country Name:<b class="ms-3">{{
              $route.query.id.country_name
            }}</b></label
          >
        </v-col>
        <v-col cols="12" md="4" lg="4" xs="12" class="ms-4">
          <label class="required" style="font-size: 16px"
            >Bank Name: <b class="ms-3">{{ $route.query.id.name }}</b></label
          >
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="4" lg="4" xs="12"
          ><v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to search the table data."
            hide-details
            class="ms-4 me-4"
            dense
            clearable
          ></v-text-field
        ></v-col>
      </v-row>
      <v-data-table fixed-header  height="55vh" :headers="headers" :items="bankBranch" dense>
        <template v-slot:item.action="{ item }">
          <v-icon small color="primary" class="mr-2" @click="nextpage(item)">
            mdi-content-save-edit-outline
          </v-icon>
        </template>
        <template v-slot:item.is_active="{ item }">
          <v-switch
            v-model="item.is_active"
            height="0px"
            dense
            color="success"
          ></v-switch>
        </template>
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import axios from "axios";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name:"Master Bank Value",
  data: () => ({
    editedIndex: -1,
    dialog: false,
    search: "",
    CountryList: [],
    bankBranch: [],
    items: ["YES", "NO", "BOTH"],
    addmasterbranch: {
      name: "",
      country_name: "",
      country_code: "",
      is_active: true,
      swift_bank: "No",
    },
    headers: [
      {
        text: "Branch code",
        align: "start",
        sortable: false,
        value: "",
      },
      { text: "Branch Name", value: "" },
      { text: "Specific branch code", value: "" },
      { text: "Active", value: "is_active" },
      { text: "Action", value: "action", sortable: false },
    ],
  }),
  components: {
    BreadCrumb,
    // Loading
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Add Master Branch"
        : "Edit Master Branch";
    },
  },
  mounted() {
    this.getcountryList();
    this.addmasterbranch.swift_bank = this.$route.query.id.swift_bank;
    this.addmasterbranch.country_name = this.$route.query.id.country_name;
    this.addmasterbranch.name = this.$route.query.id.name;
    console.log("route.query.id  " + JSON.stringify(this.$route.query.id));
  },
  methods: {
    getcountryList() {
      axios({
        url: `${process.env.VUE_APP_TRANSACATION_BASEURL}/api/v1/integrate/get-all-country-data`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.CountryList = response.data.map((i) => {
              return { text: i.country_name, values: i.iso_alpha3 };
            });
          }
          console.log("Country", response);
        })
        .catch((e) => {
          console.error(e);
          this.CountryList = [];
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.Collectiondata = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
